import { KTIcon } from "../../../../_metronic/helpers";

const NotifierEmailModalHeader = ({
  setSelectedReport,
  openNotifierEmailModal,
  setOpenNotifierEmailModal,
}) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <div>
      <h2 className="fw-bolder">{openNotifierEmailModal?.type === 'sent' ? 'Last Report sent to the emails' : openNotifierEmailModal?.type === 'admin' ? 'Admin Emails' : 'Notifier Emails'}</h2>
      </div>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => {
          setSelectedReport(null);
          setOpenNotifierEmailModal({
            status: false,
            type: ''
          });
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};

export { NotifierEmailModalHeader };
